import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from '../../../core/http/settings.service';
import { AuthServiceService } from '../../../core/http/auth-service.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss']
})
export class LogComponent implements OnInit {

  isLoading = true;
  Errors = null;
  logs:any = [];
  filterdlogs:any = [];
  data = null
  private _searchText:string ;

  get searchText(): string {
      return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterdlogs = this.filterLog(value)
}

filterLog(searchString: string) {
    return this.logs.filter( log =>
      log.Mode.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
}


  constructor(public router: Router, private modal: ModalService, private _snackBar: MatSnackBar, public setting: SettingsService, public auth: AuthServiceService) { }

  ngOnInit(): void {

    this.setting
      .getLog()
      .subscribe(
        (resSuccess) => {

          this.logs = resSuccess
          this.filterdlogs = this.logs
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

}
